var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cons"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.formattedTime))]),_c('span',{staticClass:"font-14"},[_vm._v("剩余时间")])])
}
var staticRenderFns = []

export { render, staticRenderFns }